import Screen from "@components/Screen/Screen";
import Balances from "./components/Balances";
import PriceChart from "./components/PriceChart";
import { Card, CardTitle } from "@/src/components/shad/card";
import History from "./components/History";
import MiddleTabs from "./components/MiddleTabs";
import { textVariants } from "@/src/components/Text/Text";
import { useInitData } from "@/src/hooks/useInitData";
import Banner from "./components/Banner";
import Announcement from "./components/announcement";
import BuyIcon from "@/src/assets/icons/Import.svg";
import SellIcon from "@/src/assets/icons/Export.svg";
import P2pimage from "@assets/icons/p2ptradeimage.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.home.${key}`);
  const { homeData, isLoading } = useInitData();
  return (
    <Screen loading={isLoading}>
      <div className="grid gap-5">
        <div className=" flex md:mr-2">
          <Banner data={homeData?.info.banners} />
        </div>
        <div className="grid md:grid-cols-7 gap-3">
          <div className="md:col-span-5 overflow-x-scroll grid gap-3">
            {/* <div className="md:hidden flex ">
              <Banner data={homeData?.info.banners} />
            </div> */}
            <div className="md:hidden overflow-x-hidden">
              <Announcement data={homeData?.info.announcements} />
            </div>
            <div className="md:hidden flex items-center bg-gradient-to-r from-green-100 to-indigo-100 dark:from-grey-500 dark:to-grey-400 py-4 px-3 space-x-3  rounded-lg">
              <Link
                to={"/app/trade/buy"}
                className="bg-white dark:bg-grey-700 rounded-lg flex items-center justify-center gap-2 px-4 py-3 w-full"
              >
                <img src={BuyIcon} className="h-6 w-6" alt="buy" />
                <span className={textVariants({ size: "sm" })}>
                  {trans("quickActions.buy")}
                </span>
              </Link>
              <Link
                to={"/app/trade/sell"}
                className="bg-white dark:bg-grey-700 rounded-lg flex items-center justify-center gap-2 px-4 py-3 w-full"
              >
                <img src={SellIcon} className="h-6 w-6" alt="sell" />
                <span className={textVariants({ size: "sm" })}>
                  {trans("quickActions.sell")}
                </span>
              </Link>
            </div>
            <Link
              to={"/app/trade/p2p"}
              className="md:hidden px-3 py-4 flex items-center bg-white dark:bg-grey-600 rounded-lg mb-5"
            >
              <div className="grid gap-2 w-full">
                <span className={textVariants({ font: "semibold" })}>
                  {trans("p2pCard.header")}
                </span>
                <span className={textVariants({ size: "xs", variant: "desc" })}>
                  {trans("p2pCard.desc")}
                </span>
              </div>
              <img src={P2pimage} alt="p2p" className="h-20 w-24" />
            </Link>
            <div>
              <Balances data={homeData?.info.rates} />
            </div>
          </div>
          <>
            <div className="md:col-span-2 md:block hidden  md:px-2">
              <MiddleTabs />
            </div>
          </>
        </div>
        <div className="hidden md:grid md:grid-cols-7 gap-5">
          <Card className="md:col-span-5 p-4">
            <PriceChart />
          </Card>
          <Card className="md:col-span-2 p-4">
            <CardTitle className={textVariants()}>
              {t("app.home.transactions.header")}
            </CardTitle>
            <History />
          </Card>
        </div>
      </div>
    </Screen>
  );
};

export default Home;
